import React, { useEffect, useState } from 'react';
import { Form, Input, message, Select, DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import * as accountService from '../../services/account/accountService';
import StandardDrawer from '../../components/common/StandardDrawer';

const AccountEditForm = ({ visible, account, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [employeeType, setEmployeeType] = useState('');

  useEffect(() => {
    if (visible && account) {
      // 设置表单初始值
      const empType = account.sourceCode === 1 ? 'Formal' : account.sourceCode === 2 ? 'Dummy' : '';
      form.setFieldsValue({
        loginId: account.loginId,
        name: account.name,
        mobile: account.mobile,
        employeeType: empType,
        proficiency: account.proficiency,
        expiryDate: account.expireTime ? dayjs(account.expireTime) : null,
      });
      setEmployeeType(empType);
    }
  }, [visible, account, form]);

  const handleEmployeeTypeChange = (value) => {
    setEmployeeType(value);
    if (value !== 'Dummy') {
      form.setFieldValue('expiryDate', null);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      //构造API请求数据
      const { expiryDate, ...rest } = values;
      const accountData = {
        ...rest,
        expireTime: expiryDate ? dayjs(expiryDate).format('YYYY-MM-DD') : null,
        sourceCode: values.employeeType === 'Formal' ? 1 : 2,
        id: account.id,
      };
      
      const response = await accountService.updateAccount(accountData);
      
      if (response.success) {
        message.success(t('account.updateSuccess'));
        onSuccess();
      } else {
        message.error(response.errorMessage || t('account.updateFailed'));
      }
    } catch (error) {
      console.error('Update account failed:', error);
      message.error(t('account.updateFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <StandardDrawer
      visible={visible}
      onClose={onCancel}
      onOk={handleSubmit}
      title={t('account.editTitle')}
      confirmLoading={loading}
      width={480}
      maskClosable={false}
      destroyOnClose={true}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ padding: '24px 0' }}
      >
        <Form.Item
          name="loginId"
          label={t('account.email')}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="name"
          label={t('account.name')}
          rules={[
            { required: true, message: t('account.nameRequired') },
            {
              pattern: /^[^!@#$%^&*()]+$/,
              message: t('account.nameSpecialCharNotAllowed') || '名字不能包含特殊字符 !@#$%^&*()'
            }
          ]}
        >
          <Input placeholder={t('common.pleaseInput')} />
        </Form.Item>


        <Form.Item
          name="mobile"
          label={t('account.contactPhone')}
        >
          <Input placeholder={t('common.pleaseInput')} />
        </Form.Item>

        <Form.Item
          name="employeeType"
          label={<span className="required-label">{t('account.employeeType')}</span>}
          rules={[{ required: true, message: t('account.employeeTypeRequired') }]}
        >
          <Select
            placeholder={t('common.pleaseSelect')}
            disabled
            options={[
              { value: 'Formal', label: t('account.employeeTypeFormal') },
              { value: 'Dummy', label: t('account.employeeTypeDummy') }
            ]}
            onChange={handleEmployeeTypeChange}
          />
        </Form.Item>

        {employeeType === 'Dummy' && (
          <Form.Item
            name="expiryDate"
            label={<span className="required-label">{t('account.expiryDate')}</span>}
            rules={[{ required: true, message: t('account.expiryDateRequired') }]}
          >
            <DatePicker
              style={{ width: '100%' }}
              placeholder={t('common.pleaseSelect')}
              format="DD-MM-YYYY"
            />
          </Form.Item>
        )}

      </Form>
    </StandardDrawer>
  );
};

export default AccountEditForm;